export const openLogin = (e, notice=true) => {
  e.preventDefault()
  const returnTo = location.pathname + location.search + location.hash
  sessionStorage.setItem('after_login_url', returnTo)

  document.dispatchEvent(new CustomEvent('modal:open', { detail: { size: 'small' }}))
  fetch(`/login?return_to=${encodeURIComponent(returnTo)}${notice ? '&notice=true' : ''}`, {
    headers: { Accept: 'text/vnd.turbo-stream.html' }
  })
    .then(r => r.text())
    .then(Turbo.renderStreamMessage)
}

export const openLyricsModal = (sv) => {
    const modal = document.querySelector("[data-controller='modal']")
    const frame = document.querySelector("turbo-frame#active-modal-content")

    if (modal && frame) {
      document.dispatchEvent(new CustomEvent("modal:open"))
      frame.innerHTML = ""
      frame.setAttribute("src", `/song_versions/lyrics/${sv.id}`)
    }
  }

export const openProInformationModal = (songVersionId) => {
  const modal = document.querySelector("[data-controller='modal']")
  const frame = document.querySelector("turbo-frame#active-modal-content")

  if (modal && frame) {
    document.dispatchEvent(new CustomEvent("modal:open"))
    frame.innerHTML = ""
    frame.setAttribute("src", `/song_versions/pro_information/${songVersionId}`)
  }
}
